import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { get as _get } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';
import { LightThemeColors } from '../../Themes';
import VFText from '../../VFText';
import StepStatuses from '../Utils/StepStatuses';

import styles from './StepHeader.styles';

const StepHeader = ({
  step,
  titlePropName,
  accessibilityLabelPropName,
  renderTitle,
  titleContainerStyle,
  index,
  isActive,
  isNew,
  isSkipped,
  isCompleted,
  isFinalStep,
  steps,
  theme,
  ...props
}) => {
  const textStyle = isActive ? styles.activeHeaderTextStyle : styles.inActiveHeaderTextStyle;
  const circleStyle = isActive
    ? styles.activeCircleStyle(theme)
    : isNew || isSkipped
    ? styles.newOrSkippedCircleStyle(theme)
    : styles.completedCircleStyle(theme);

  return (
    <View style={styles.header} testID={FoundationTestKeys.timelineStepHeaderHeader}>
      <View testID={FoundationTestKeys.timelineStepHeaderActiveView}>
        <View style={circleStyle} testID={FoundationTestKeys.timelineStepHeaderCircle}>
          {isActive && (
            <View
              style={styles.activeInnerCircleStyle(theme)}
              testID={FoundationTestKeys.timelineStepHeaderActiveCircle}
            />
          )}
        </View>
      </View>

      {renderTitle ? (
        renderTitle(
          step,
          index,
          isActive,
          { isNew, isSkipped, isCompleted, isFinalStep, ...props },
          steps,
        )
      ) : (
        <View
          style={[styles.headerTextContainerStyle, titleContainerStyle]}
          testID={FoundationTestKeys.timelineStepHeaderTitleView}
        >
          <VFText
            style={textStyle}
            i18nKey={step[titlePropName]}
            testKey={_get(step, `extraData[${accessibilityLabelPropName}]`)}
          />
        </View>
      )}
    </View>
  );
};

StepHeader.defaultProps = {
  theme: LightThemeColors,
};

StepHeader.propTypes = {
  step: PropTypes.shape({
    status: PropTypes.oneOf(Object.values(StepStatuses)),
    title: PropTypes.string,
  }),
  renderTitle: PropTypes.func,
  titlePropName: PropTypes.string,
  accessibilityLabelPropName: PropTypes.string,
  titleContainerStyle: ViewPropTypes.style,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.oneOf(Object.values(StepStatuses)),
      title: PropTypes.string,
    }),
  ),
  index: PropTypes.number,
  isActive: PropTypes.bool,
  isNew: PropTypes.bool,
  isSkipped: PropTypes.bool,
  isCompleted: PropTypes.bool,
  isFinalStep: PropTypes.bool,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default StepHeader;
